import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/bullet-list.svg";
var BulletListSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  BulletListSolid_default as default
};
